import { Suspense } from "react"
import { Link } from "react-router-dom-7"

import { useStudentUserInfo } from "~/domain/user-session"
import { MaterialIcon, PopupHint } from "~/shared/ui"

import { Counter } from "./Counter"
import { actionButtonSize, iconStyle } from "./style"
import { useMediaQuery } from "react-responsive"
import { breakPoints } from "~/shared/ui/constants"
import css from './index.module.scss'

const SIMULATE_MESSAGE = false

function MessageCounter({ count } : {count : number}) {
	return <Counter count={count} />
}

export function MessageButton() {
	const studentUserInfo = useStudentUserInfo()
	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	if (!studentUserInfo) return null

	const messageCount = SIMULATE_MESSAGE ? 4 : studentUserInfo?.EIOS_MESSAGE_CNT ?? 0

	return (
		<PopupHint text="Сообщения" position="bottom">
			<div style={{ position: "relative" }}>
				<Link to="/main/messages" style={{textDecoration: "none"}}>
					<MaterialIcon
						name="mail"
						outlined
						className={messageCount > 0 ? css.hasMessageAnimation : ''}
						style={{
							flex: "0 1 auto",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: isSmallDevice ? "1.6rem" : "2.2rem",
							...actionButtonSize,
							...iconStyle }}
					/>
				</Link>
				{messageCount > 0 && <Suspense>
					<MessageCounter count={messageCount} />
				</Suspense>}
			</div>
		</PopupHint>
	)
}
